"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";

/** A monospace value with a copy button, e.g. a model ID. */
export function CopyText({ value, label }: { value: string; label: string }) {
	const [done, setDone] = useState(false);
	return (
		<button
			type="button"
			title={label}
			onClick={() => {
				void navigator.clipboard.writeText(value);
				setDone(true);
				setTimeout(() => setDone(false), 1500);
			}}
			className="inline-flex items-center gap-2 rounded-full border border-border bg-muted/40 px-3 py-1 font-mono text-xs hover:border-brand/50"
		>
			{value}
			{done ? (
				<Check className="size-3.5 text-emerald-500" />
			) : (
				<Copy className="size-3.5 text-muted-foreground" />
			)}
		</button>
	);
}
